module.exports = __webpack_public_path__ + "static/media/mastercard.9ff84e23.svg";